export default "__VITE_ASSET__DdfQDDo0__"